export default __webpack_public_path__ + "assets/images/icon-close-big.04558ee23f2c16d39bd61952a9ed99bf.svg";